import React from "react";
import { Grid, Typography } from "@mui/material";

const GCPendingPoCard = ({ items }) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container">
      {items.map((item, index) => (
        <Grid item xs={12} sm={6} md={6} key={index}>
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              {/* <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                ItemCode
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
               { item.itemCode}
                </Typography>
              </Grid>
               */}
              {/* <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                ItemName
                </Typography>
              </Grid> */}
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
               { item.itemName}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                PO Qty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.POQty}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                GRN Qty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.GRNQty}
                </Typography>
              </Grid>
              
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                Diff. Qty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.DiffQty}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                CTN Qty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.totalCTNQty}
                </Typography>
              </Grid>
              {/* <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                Total BaseQty
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.totalBaseQty}
                </Typography>
              </Grid> */}
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                CBM
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.totalCBM}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                Pallet
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.totalPallet}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                Qty / Pallet
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.QtyPerPallet}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
                BaseQty / Pallet
                </Typography>
              </Grid>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" className="value">
               { item.BaseQtyPerPallet}
                </Typography>
              </Grid>
              {/* <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
               Ref. No
                </Typography>
              </Grid> */}
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
               { item?.SuppRefNo1}
                </Typography>
              </Grid>
              
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default GCPendingPoCard;
